import { useModal } from "../../../utils/ModalContext";
import { FiX, FiChevronRight } from "react-icons/fi";
import WalletModalStyleWrapper from "./WalletModal.style";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import metamaskIcon from "../../../assets/images/icon/MetaMask.svg";
import walletConnect from "../../../assets/images/icon/WalletConnect.svg";
import { useApiContract, useMoralis, useMoralisWeb3Api, useNativeBalance, useWeb3Contract } from "react-moralis";
import {ImSpinner} from 'react-icons/im'
import logo from "../../../assets/images/logo/logo.png";

const WalletModal = () => {

  const { walletModalHandle, oopsModalHandle, messageHandle, account } = useModal();
  const {authenticate, isAuthenticated, isAuthenticating, authError, enableWeb3, user, isWeb3Enabled, Moralis} = useMoralis();

  console.log('web3', [isWeb3Enabled]);
  return (
    <>
      <WalletModalStyleWrapper className="modal_overlay">
        <div
          className="mint_modal_box"
        >
            {isAuthenticating && 
            <div className="modal-loading">
              <div className="loading_icon">
                <ImSpinner size={40} color="white" />
                </div>
            </div>}
          <div className="mint_modal_content" style={{opacity: isAuthenticating ? 0.4 : 1}}>
            <div className="modal_header">
              <h2>CONNECT WALLET</h2>
              <button onClick={() => walletModalHandle()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <p>
                Please select a wallet to connect for start Minting your NFTs
              </p>
              <div className="wallet_list" >
                <a href="# " 
                  onClick={
                    async () => {
                      authenticate(
                        {
                          signingMessage:"Connect with ALPHA OCTOPUS",
                          onSuccess:  async (user) => {
                        
                            await enableWeb3();
                            walletModalHandle();
                          }, 
                          // onComplete: async(u) => {
                          //   // }
                          //   console.log('user', u?.get('ethAddress'), "acc", account, 'provider', provider);
                          //   const Y5b = await getY5Balance(u?.get("ethAddress"), provider);
                          //   console.log('Y5b', Y5b);
                          //   walletModalHandle();

                          // },
                          onError: () => {walletModalHandle(); messageHandle(authError?.message); oopsModalHandle();}
                        }
                        );
                    
                  }
                    }>
                  <img src={metamaskIcon} alt="Meta-mask ALPHA OCTOPUS" />
                  MetaMask
                  <span>
                    <FiChevronRight />
                  </span>
                </a>
                {/* <a href="# ">
                  <img src={trustWalletIcon} alt="Trust" />
                  Trust Wallet
                  <span>
                    <FiChevronRight />
                  </span>
                </a> */}
                <a href="# " 
                  onClick={
                    async () => {
                      await enableWeb3({provider: 'walletconnect'});
                      authenticate(
                        {
                          singingMessage:"Connect with ALPHA OCTOPUS",
                          provider:'walletconnect', 
                          chainId:3, 
                          onSuccess:() => walletModalHandle(), 
                          onError: (er) => { walletModalHandle(); messageHandle(authError?.message); oopsModalHandle();}
                        }
                        );
                    }}>
                  <img src={walletConnect} alt="Wallet" />
                  WalletConnect
                  <span>
                    <FiChevronRight />
                  </span>
                </a>
                <a href="# " onClick={async () => { 
                  await enableWeb3({provider: "web3Auth"});
                  authenticate({
                  provider:"web3Auth",
                  signingMessage:"Connect With ALPHA OCTOPUS", 
                  clientId:"BN0bn7QuOr3rrIFyGNIdFIaMZXdHQ0v6C2YrDlIa6GNimYvIBgEUDgpHbWPx1oqlqeOWvGmJNh-t7dg_S9KM9O4", 
                  appLogo:logo,
                  loginMethodsOrder:["google", "facebook", "twitter", "reddit", "discord", "github","linkedin","email_passwordless"],
                  onError: () => {walletModalHandle(); messageHandle(authError?.message); oopsModalHandle();}
                });
                  //  !isAuthenticating && walletModalHandle();
                   }}>
                  {/* <img src={formatic} alt="Coinbase" /> */}
                  {isAuthenticating? "Connecting with ALPHA OCTOPUS" : "More Options"}
                  <span>
                    <FiChevronRight />
                  </span>
                </a>
              </div>
              <div className="modal_bottom_text">
                By connecting your wallet, you agree to our
                <a href="# ">Terms of Service</a>
                <a href="# ">Privacy Policy</a>
              </div>
            </div>

            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </WalletModalStyleWrapper>
    </>
  );
};

export default WalletModal;
